import React, { useEffect, useState } from 'react';

import { Box, Divider, Skeleton, Stack } from '@chakra-ui/react';
import { useCurrentProvider } from 'reducers/reviewResultSlice';
import usePeerFeedbackData from 'screens/performanceReview/components/PeerFeedback/hooks/dataHooks';
import useIsManagerView from 'screens/performanceReview/hooks/useIsManagerView';

import { Summarize } from 'assets/assetsV1/iconComponents';

import { ResultRenderer } from '../../components/results/ResultRenderer';
import ReviewResultGoalSummary from './ReviewResultGoalSummary';

const SummarizeIcon = ({ ...props }) => <Summarize boxSize="20px" {...props} />;

const options = [
  {
    label: 'Summary',
    Icon: SummarizeIcon,
  },
];

const PeopleViewGoalScrollableNav = ({ questionId, goalId, okr, ...question }) => {
  const { isManagerView } = useIsManagerView();
  const currentProvider = useCurrentProvider();
  const { data = [], isLoading } = usePeerFeedbackData({
    goalId: okr?.uuid ?? goalId,
    questionId,
    isManagerView,
    providerType: currentProvider?.providerType,
  });

  const [, setManagerOptions] = useState([]);

  useEffect(() => {
    if (isManagerView && !isLoading) {
      const optionsArray = data?.map(({ employee }) => ({
        label: employee?.id,
        src: employee?.profilePhotoSrc,
      }));
      setManagerOptions([...options, ...optionsArray]);
    }
  }, [isLoading, isManagerView, data]);

  if (isManagerView && isLoading) {
    return (
      <Stack>
        <Skeleton height="20px" />
        <Skeleton height="20px" />
        <Skeleton height="20px" />
      </Stack>
    );
  }

  return (
    <Box
      sx={{
        width: '100%',
        '.scrollableSection': {
          background: '#F5F7F9',
        },
        borderRadius: '4px',
        overflow: 'hidden',
        padding: '0 12px 12px 12px',
      }}
    >
      <Box bg="#F5F7F9" p="16px">
        <ReviewResultGoalSummary okr={okr} />
      </Box>
      <Box px="16px">
        <Divider color="#EBEFF3" opacity={1} />
      </Box>
      <Box bg="#F5F7F9" p="16px">
        <ResultRenderer {...question} />
      </Box>
    </Box>
  );
};

export default PeopleViewGoalScrollableNav;
